import React from "react";
import {
  MdAccountBalanceWallet,
  MdAccountBox,
  MdAssessment,
  MdBookmark,
  MdDelete,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdPerson,
  MdQuestionAnswer,
  MdSearch,
  MdSettings
} from "react-icons/md";
import img1 from "./img1.png";
import img2 from "./img2.png";
import img3 from "./img3.svg";
import img4 from "./img4.svg";

const Ig1 = () => {
  return (
    <>
      <h1 className="text-3xl my-5 font-semibold">Comet wallet</h1>
      <div>Credits for design:</div>
      <ul className="list-disc pl-6 mt-2">
        <li>
          <a href="https://www.instagram.com/p/CFeJW1agMQJ/" target="_blank">
            https://www.instagram.com/p/CFeJW1agMQJ
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/saepul.designpro/" target="_blank">
            https://www.instagram.com/saepul.designpro/
          </a>
        </li>
      </ul>
      <div
        style={{ minHeight: 500 }}
        className="border border-blue-300 mt-5 bg-blue-50 p-10 rounded-3xl shadow-2xl"
      >
        <div className="flex max-h-12 items-center place-content-between mb-5 col-span-12">
          <div className="text-lg font-bold leading-relaxed">comet wallet</div>
          <div className="flex items-center rounded-full px-5 h-10 bg-white">
            <input
              type="text"
              style={{ width: 200 }}
              className="border px-3 py-2 bg-transparent outline-none border-none"
              placeholder="Search everything"
            />
            <MdSearch className="text-gray-500" />
          </div>
          <div className="flex items-center">
            <div className="bg-white rounded-full p-3 relative cursor-pointer">
              <MdQuestionAnswer />
              <div className="shadow-lg rounded-full p-3 bg-purple-600 text-white absolute -top-2 -right-2 text-xs h-5 w-5 flex items-center justify-center">
                2
              </div>
            </div>
            <img
              src={img1}
              className="rounded-full ml-6 h-10 mb-0 cursor-pointer"
            />
            <div className="flex flex-col ml-2">
              <div className="font-bold">Martin</div>
              <div className="text-gray-400 font-light text-xs mt-1">admin</div>
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="hidden md:flex text-gray-400  items-center flex-col col-span-2 rounded-lg p-5">
            <div className="p-4 mb-8 cursor-pointer shadow-lg bg-indigo-500 rounded-full w-min text-white">
              <MdAccountBalanceWallet size={22} />
            </div>

            <div className="mb-8 cursor-pointer">
              <MdAssessment size={22} />
            </div>
            <div className="mb-8 cursor-pointer">
              <MdBookmark size={22} />
            </div>
            <div className="mb-8 cursor-pointer">
              <MdAccountBox size={22} />
            </div>
            <div className="mb-8 cursor-pointer">
              <MdSettings size={22} />
            </div>
          </div>

          <div className="grid grid-cols-12 gap-8 flex-grow">
            <div className="col-span-12 md:col-span-9 rounded-lg p-5">
              <div className="flex place-content-between">
                <h1 className="text-2xl font-bold text-gray-800">
                  My Dashboard 🚀
                </h1>
                <div className="flex items-center px-4 py-3 rounded-full bg-gray-200 cursor-pointer border border-gray-400">
                  <div className="mr-2 text-gray-700">This week</div>
                  <MdKeyboardArrowDown />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-10 mt-4">
                <div className="bg-blue-100 rounded-3xl p-8 flex flex-col items-center shadow-sm col-span-2 md:col-span-1">
                  <div className="flex justify-center mb-2">
                    <img className="rounded-full h-16 mb-0" src={img1} />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-500">
                    Welcome back,
                  </h3>
                  <h2 className="text-xl font-bold text-gray-600">
                    Martin Schnurer
                  </h2>
                  <button className="border py-4 bg-white rounded-full w-full mt-8 font-bold text-xs text-gray-600">
                    View Analysis
                  </button>
                </div>
                <div className="col-span-2 md:col-span-1">
                  <h1 className="text-2xl font-bold text-gray-700">
                    Dispute progress
                  </h1>
                  <div className="mt-2">
                    <span className="font-bold">30 dispute</span> in this month
                  </div>
                  <div className="grid grid-cols-2 mt-10 ">
                    <div>
                      <div className="flex items-center justify-center text-gray-500 rounded-full h-12 w-12 bg-red-100">
                        <MdPerson />
                      </div>
                      <h1 className="text-2xl font-semibold text-gray-700 mt-5">
                        Generated
                      </h1>
                      <div>
                        <b>200</b> Accounts
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center text-gray-500 rounded-full h-12 w-12 bg-purple-100">
                        <MdDelete />
                      </div>
                      <h1 className="text-2xl font-semibold text-gray-700 mt-5">
                        Removed
                      </h1>
                      <div>
                        <b>12</b> Accounts
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-10 mt-12">
                <div className="col-span-2 md:col-span-1">
                  <h1 className="text-2xl">Credit by categories</h1>
                  <h3>Quick overview of your credit categories</h3>
                  <div className="flex p-5 mt-8 bg-purple-100 rounded-lg transform hover:-translate-x-6 transition-transform duration-500 cursor-pointer">
                    <img src={img3} className="m-0 mr-5" />
                    <div className="flex flex-col flex-grow">
                      <div className="text-lg font-bold text-gray-700">
                        Installment
                      </div>
                      <div className="text-xs text-gray-500">
                        Samantha William
                      </div>
                    </div>
                    <div className="font-bold ml-3">$240</div>
                  </div>
                  <div className="flex mt-5 p-5 bg-white rounded-lg transform hover:-translate-x-6 transition-transform duration-500 cursor-pointer">
                    <img src={img4} className="m-0 mr-5" />
                    <div className="flex flex-col flex-grow">
                      <div className="text-lg font-bold text-gray-700">
                        Other loans
                      </div>
                      <div className="text-xs text-gray-500">Jonathan W.</div>
                    </div>
                    <div className="font-bold ml-3">$40</div>
                  </div>
                </div>
                <div className="border-t border-gray-300 md:hidden h-1 w-full col-span-2"></div>
                <div className="col-span-2 md:col-span-1">
                  <div className="rounded-2xl p-6 flex flex-col items-center bg-white">
                    <h1 className="text-2xl">Credit report</h1>
                    <div className="flex items-center mt-8">
                      <div className="w-10 h-10 rounded-full border flex items-center justify-center cursor-pointer">
                        <MdKeyboardArrowLeft />
                      </div>
                      <img
                        className="mx-10 rounded-full w-20 h-20"
                        src={img2}
                      />
                      <div className="w-10 h-10 rounded-full border flex items-center justify-center cursor-pointer">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                    <div className="text-sm mt-2">You are</div>
                    <h1 className="text-2xl">Growing star 🥳</h1>
                  </div>

                  <div className="md:hidden p-3 bg-white rounded-2xl mt-8 flex justify-center items-center cursor-pointer">
                    See more
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-3 border rounded-lg p-5 hidden md:block">
              <div className="text-3xl font-bold mb">$ 1,280.50</div>
              <div className="font-medium text-gray-500 text-xs">
                Monday, 07 September 2020
              </div>
              <div className="mt-5">
                <div className="font-bold mb-5">Today</div>
                <div className="flex items-center mb-7 cursor-pointer rounded-xl px-4 hover:shadow-md transition-all hover:-translate-y-1 transform duration-500">
                  <img className="h-10 mr-5 m-0" src={img3} />
                  <div className="flex-grow hidden md:block">
                    <div>Hunter macbook</div>
                    <div>0953-01238593102</div>
                  </div>
                  <div>
                    <MdKeyboardArrowRight />
                  </div>
                </div>
                <div className="flex items-center mb-7 cursor-pointer rounded-xl px-4 hover:shadow-md transition-all hover:-translate-y-1 transform duration-500">
                  <img className="h-10 mr-5 m-0" src={img3} />
                  <div className="flex-grow hidden md:block">
                    <div>Hunter macbook</div>
                    <div>0953-01238593102</div>
                  </div>
                  <div>
                    <MdKeyboardArrowRight />
                  </div>
                </div>
                <div className="flex items-center mb-7 cursor-pointer rounded-xl px-4 hover:shadow-md transition-all hover:-translate-y-1 transform duration-500">
                  <img className="h-10 mr-5 m-0" src={img3} />
                  <div className="flex-grow hidden md:block">
                    <div>Hunter macbook</div>
                    <div>0953-01238593102</div>
                  </div>
                  <div>
                    <MdKeyboardArrowRight />
                  </div>
                </div>
                <button className="w-full bg-gray-200 text-gray-700 rounded-full py-3 font-medium">
                  View More
                </button>
              </div>
              <div className="mt-10">
                <h1 className="text-xl font-bold mb-1">Loan Calculator</h1>
                <h3 className="text-sm text-gray-500 font-semibold">
                  Select the amount needed and the reimbursement period
                </h3>
                <div className="bg-blue-100 rounded-3xl overflow-hidden mt-6">
                  <div className="flex flex-col bg-blue-200 w-8/12 p-5">
                    <div className="text-center text-lg font-semibold">
                      $ 450.50
                    </div>
                    <div className="text-xs text-center">All loan amount</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ig1;
